import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddRescueToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/rescue/store/rescue.actions'
import { addRescueItem } from '../../timeline/store/timeline.actions'
import { RescueConstants } from '../../procedures/rescue/store/rescue.constants'

export function* saveRescueQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addRescueToTimeline } = quickActionsObject
  if (addRescueToTimeline) {
    yield put(addRescueItem())
    yield put(setAddRescueToTimeline(false))
    yield put(resetState())
  }
}

export function* saveRescueQuickActionTimeLineRowSaga() {
  yield takeLatest([RescueConstants.SET_ADD_TO_TIMELINE], saveRescueQuickActionTimeLineRow)
}
